import styled from 'styled-components';

import { ModalContent as DefaultModalContent } from 'components/modal';

export const ModalContent = styled(DefaultModalContent)`
  .modal-scroller {
    padding-top: 2rem;
  }

  .modal-inner {
    width: 100%;
    max-width: 100%;
    padding: 0 2rem 2rem 2rem;
  }
`;
